import { HomepageSettings } from './../../../../interfaces/settings';
import { DataService } from 'src/app/services/data.service';
import { Lesson } from './../../../../interfaces/course';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { State } from 'src/app/interfaces/enums';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  searchForm: FormGroup;
  enrollForm: FormGroup;

  upcomingSession: any;
  featuredSession: any;
  categories: string[];

  title: string;
  titleItems: string[];

  social: any;

  promotions: Lesson[];

  hs: HomepageSettings = {};

  showFeaturedSession = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private data: DataService
  ) {
    this.searchForm = this.fb.group({
      c: new FormControl(''),
      s: new FormControl(''),
      l: new FormControl('')
    })

    this.enrollForm = this.fb.group({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email])
    })
  }

  ngOnInit() {
    this.data.getUpcomingLesson().subscribe((res) => {
      if(res && res.data){
        this.upcomingSession = res.data;

        this.getHomepageSettings();
      }
    })
  }

  submit(){
    this.router.navigate(['/courses'], {
      queryParams: this.searchForm.value
    })
  }

  async getHomepageSettings(){
    this.data.getSettings('configs').subscribe((res) => {
      if(res && res.data){
        const hs = res.data;

        this.categories = hs.categories;
        this.title = hs.title;
        this.titleItems = hs.titleItems;
        this.social = hs.social;

        this.data.getAllPromotions().subscribe((res) => {
          if(res && res.data){
            this.promotions = res.data;
          }
        })

        this.data.getFeatured().subscribe(async(res) => {
          if(res){
            this.featuredSession = res.data;

            if(this.featuredSession){
              this.featuredSession.attendees = (await this.data.getEnrollments({state: State.Active, session: this.featuredSession.session._id}).pipe(map(res => res.data.length)));
            }

            this.featuredSession.daysLeft = {
              number: _.first(_.split(moment(this.featuredSession.session.startTime).toNow(true), ' ')),
              word: _.last(_.split(moment(this.featuredSession.session.startTime).toNow(true), ' '))
            }
          }
        })
      }
    })
  }

  enroll(){
    try{
      if(this.enrollForm.invalid){
        throw Error('Form is invalid.');
      }

      const {value} = this.enrollForm;

      this.router.navigate(['/authentication/signup'], {
        queryParams: {
          name: value.name,
          email: value.email,
          type: 'student'
        }
      })

    }catch({message}){
      this.toastr.error(message);
    }
  }

}
